export default __webpack_public_path__ + "static/media/people3.51d73e93.png";